exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, "\n[data-v-5fac49a8] .van-icon-arrow-left {\n  color: #a5a5a5 !important;\n}\n", "", {"version":3,"sources":["/Users/quanenxi/WS/xinnuo-nanyang/xinnuo-portal-vue/src/mobile/DataType.vue","/Users/quanenxi/WS/xinnuo-nanyang/xinnuo-portal-vue/src/mobile/DataType.vue"],"names":[],"mappings":";AA8DA;EACE,0BAAA;CC7DD","file":"DataType.vue","sourcesContent":["\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n/deep/ .van-icon-arrow-left {\n  color: #a5a5a5 !important;\n}\n"," /deep/ .van-icon-arrow-left {\n  color: #a5a5a5 !important;\n}\n"],"sourceRoot":""}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"sourceMap":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-5fac49a8","scoped":true,"hasInlineConfig":false}!./node_modules/less-loader/dist/cjs.js?{"sourceMap":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/mobile/DataType.vue
// module id = d3da
// module chunks = 1